
export class ControlEscriturasModel{

	constructor(		
        public activarChek:boolean,
		public nid:number,
		public vdescripcion:string,
        ){}        
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ControlEscriturasMasiva/ControlEscriturasMasiva.model.ts